module.exports = __webpack_public_path__ + "4b00d5cfe7cc261774071f04eddbc9e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/other-with-color.svg
// module id = 3638
// module chunks = 6